import React from 'react';
import styled from 'styled-components';
import { LogsFilters } from '../../store/api/logsApi';
import { Input, Select } from '../../styles/components';
import { 
  MagnifyingGlassIcon,
  CalendarDaysIcon,
  FunnelIcon,
  GlobeAltIcon,
  UserIcon
} from '@heroicons/react/24/outline';

const SearchContainer = styled.div`
  position: relative;
  
  svg {
    position: absolute;
    left: ${props => props.theme.spacing.sm};
    top: 50%;
    transform: translateY(-50%);
    height: 1.25rem;
    width: 1.25rem;
    color: ${props => props.theme.colors.gray[400]};
  }
`;

const SearchInput = styled(Input)`
  padding-left: ${props => props.theme.spacing.xl};
  width: 100%;
  
  @media (min-width: 768px) {
    width: 20rem;
  }
`;

const DateInput = styled(Input)`
  padding-left: ${props => props.theme.spacing.xl};
  width: 100%;

  @media (min-width: 768px) {
    width: 14rem;
  }
`;

const FilterSelect = styled(Select)`
  width: 100%;
  
  @media (min-width: 768px) {
    width: 10rem;
  }
`;

const FilterRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.md};
  
  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`;

interface LogsFiltersProps {
  filters: LogsFilters;
  onFilterChange: (key: keyof LogsFilters, value: any) => void;
}

export function LogsFiltersComponent({ filters, onFilterChange }: LogsFiltersProps) {
  return (
    <FilterRow>
      <SearchContainer>
        <MagnifyingGlassIcon />
        <SearchInput
          placeholder="Search clients..."
          value={filters.clientId || ''}
          onChange={(e) => onFilterChange('clientId', e.target.value || undefined)}
        />
      </SearchContainer>
      
      <FilterSelect
        value={filters.httpMethod || ''}
        onChange={(e) => onFilterChange('httpMethod', e.target.value || undefined)}
      >
        <option value="">All Methods</option>
        <option value="GET">GET</option>
        <option value="POST">POST</option>
        <option value="PUT">PUT</option>
        <option value="DELETE">DELETE</option>
        <option value="PATCH">PATCH</option>
      </FilterSelect>
      
      <FilterSelect
        value={filters.statusCode || ''}
        onChange={(e) => onFilterChange('statusCode', e.target.value ? parseInt(e.target.value) : undefined)}
      >
        <option value="">All Status</option>
        <option value="200">200 OK</option>
        <option value="201">201 Created</option>
        <option value="400">400 Bad Request</option>
        <option value="401">401 Unauthorized</option>
        <option value="403">403 Forbidden</option>
        <option value="404">404 Not Found</option>
        <option value="500">500 Server Error</option>
      </FilterSelect>
      
      <SearchContainer>
        <CalendarDaysIcon />
        <DateInput
          type="datetime-local"
          value={filters.startDate || ''}
          onChange={(e) => onFilterChange('startDate', e.target.value || undefined)}
        />
      </SearchContainer>
      
      <SearchContainer>
        <CalendarDaysIcon />
        <DateInput
          type="datetime-local"
          value={filters.endDate || ''}
          onChange={(e) => onFilterChange('endDate', e.target.value || undefined)}
        />
      </SearchContainer>
    </FilterRow>
  );
}